import { useDispatch, useSelector } from "react-redux"
import React, { useEffect, useState } from "react"
import { useFormikContext } from "formik"
import { fetchBanks } from "../../../../../redux/actions/MasterDataAction.jsx"
import { Card, CardBody, CardHeader } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { SelectInput, TextInput } from "../../../../../component/index.jsx"
import { useTranslation } from "react-i18next"

export const AccountBankIndividual = ({ isReadOnly }) => {
  const { values: formValues } = useFormikContext()

  const { MasterData } = useSelector((state) => state)
  const dispatch = useDispatch()
  const {t} = useTranslation()
  const [bankId, setBankId] = useState(formValues["bank_id"])
  const [bankList, setBankList] = useState([])

  useEffect(() => {
    dispatch(fetchBanks())
  }, [])

  useEffect(() => {
    if (formValues.hasOwnProperty("bank_id")) {
      setBankId(formValues["bank_id"])
    }
  }, [formValues["bank_id"]])

  useEffect(() => {
    if (MasterData.bankList.length !== 0) {
      setBankList(
        MasterData.bankList.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [MasterData.bankList])

  function onChangeBank(e) {
    setBankId(e)
  }

  return (
    <Card>
      <CardHeader title={"Akun Bank mitra".toUpperCase()} />
      <CardBody>
        <RowModule>
          <>
            <SelectInput
              required
              name="bank_id"
              onChange={onChangeBank}
              editable={!isReadOnly}
              label={t("label_bank_name")}
              placeholder={t("placeholder_select_bank_name")}
              value={bankId}
              options={bankList}
            />
          </>

          <>
            <TextInput
              required
              editable={!isReadOnly}
              label={t("label_account_number")}
              name="bank_account_number"
              placeholder={t("placeholder_input_bank_number")}
              value={!formValues?.bank_id && ""}
            />
          </>
        </RowModule>

        <RowModule>
          <>
            <TextInput
              required
              editable={!isReadOnly}
              label={t("label_account_name")}
              name="bank_account_name"
              placeholder={t("placeholder_input_account_name")}
              value={!formValues?.bank_id && ""}
            />
          </>
        </RowModule>
      </CardBody>
    </Card>
  )
}